import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import { useHeaderStore } from "@companion-core/shared/app/Store/header";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { Button } from "@companion-core/shared/app/Components/Button";
import { useOnboardingStore } from "@companion-core/shared/app/Store/onboardingStore";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { useDynamicPageStepperStore } from "@companion-core/shared/app/Store/dynamicPageStepperStore";
import { getOptions } from "@companion-core/shared/app/Utils/config";

import "@companion-core/web/src/Assets/Styles/scss/onboardingRequestConfirmation.scss";

export const OnboardingBellConfirmation = () => {
  const { setDisabledHeader } = useHeaderStore();
  const { universe } = useOnboardingStore();
  const { pages, setStepIndex } = useDynamicPageStepperStore();
  const navigate = useNavigate();
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const { t } = useTranslation();
  const home: string = getOptions().homeRoutes?.web?.logged;
  const backgroundImage = useMemo(() => {
    return universe?.medias?.[0]?.url
      ? getCloudinaryOptimizedUrl(universe?.medias?.[0]?.url, {
          contentType: "image",
          width: 720,
        })
      : undefined;
  }, [universe]);

  useMountEffect(() => {
    setDisabledHeader(true);

    return () => {
      setDisabledHeader(false);
    };
  });

  const handleContinue = () => {
    const pushNotificationBlockIndex = pages["onboarding"]?.blocks.find(
      (block) => block.block.slug === "push-notification"
    )?.block.order;
    if (pushNotificationBlockIndex) {
      setStepIndex(pushNotificationBlockIndex - 1);
      navigate("/onboarding");
    } else {
      navigate(`/${home}`);
    }
  };

  return (
    <section data-testid="onboarding-bell-confirmation" className="onboarding-request-confirmation">
      <div className="onboarding-request-confirmation__media">
        <img
          data-testid="onboarding-bell-confirmation__img"
          className="onboarding-request-confirmation__img"
          src={backgroundImage}
          alt=""
        />
      </div>
      <div className="onboarding-request-confirmation__content">
        <div className="onboarding-request-confirmation__content-body">
          <FontIcon
            data-testid="onboarding-bell-confirmation__icon"
            name="JP-Circle-check"
            size={30}
          />
          <h1
            data-testid="onboarding-bell-confirmation__title"
            className="onboarding-request-confirmation__content-title title-3">
            {t("onboarding.bell.confirmation.title")}
          </h1>
          <p
            data-testid="onboarding-bell-confirmation__description"
            className="onboarding-request-confirmation__content-description body-text-6">
            {t("onboarding.bell.confirmation.description")}
          </p>
        </div>

        <Button
          testID="onboarding-bell-confirmation__button"
          label={t("onboarding.bell.confirmation.button")}
          type={isMobileSize ? "secondary" : "primary"}
          negative={isMobileSize}
          size={isMobileSize ? "full" : "large"}
          onClick={handleContinue}
        />
      </div>
    </section>
  );
};
